import TransformationCapabilitiesDto from "./TransformationCapabilitiesDto";

class TransformationLinkDto extends TransformationCapabilitiesDto {


}

export default TransformationLinkDto;
